import React, { memo } from 'react';
import { Checkbox } from 'antd';
import 'antd/lib/checkbox/style/index.css';

function CheckBox({ isChecked }: { isChecked: boolean }) {
	return <Checkbox checked={isChecked} />;
}

export default memo(CheckBox);
